<igo-spinner igoSpinnerActivity />

@if (authConfig && authConfig.url) {
  <igo-auth-form />
}

@if (header) {
  <app-header [config]="header" [lang]="lang()" />
}

<app-portal igoStopDropPropagation />

@if (hasFooter) {
  <app-footer />
}
